// extracted by mini-css-extract-plugin
module.exports =  {"slider":"_9330de7794--slider--cX_fm","slider-overflow--hidden":"_9330de7794--slider-overflow--hidden--efKuN","slider-list":"_9330de7794--slider-list--JbVwc"};